module.exports = __webpack_public_path__ + "media/assets/icons/quill/list-bullet-1a8b7ae83957691fef909445e76746e9.svg";